var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    [
      _c("v-card-text", [
        _c("strong", [_vm._v(_vm._s(_vm.entityMetadata.displayName) + ":")]),
      ]),
      _vm.entityMetadata.metadataType == _vm.metadataType.Enum
        ? _c(
            "div",
            { staticClass: "entity-metadata-enum-value" },
            [
              _c("v-select", {
                attrs: {
                  dense: "",
                  label: "valore",
                  clearable: "",
                  "hide-details": "",
                  items: _vm.entityMetadata.options,
                },
                model: {
                  value: _vm.entityMetadata.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.entityMetadata, "value", $$v)
                  },
                  expression: "entityMetadata.value",
                },
              }),
            ],
            1
          )
        : _vm.entityMetadata.metadataType == _vm.metadataType.Datetime
        ? _c(
            "div",
            { staticClass: "entity-metadata-datetime-value" },
            [
              _c("DatePicker", {
                attrs: {
                  textBoxLabel: "data",
                  hide_details: true,
                  clearable: true,
                },
                model: {
                  value: _vm.entityMetadata.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.entityMetadata, "value", $$v)
                  },
                  expression: "entityMetadata.value",
                },
              }),
            ],
            1
          )
        : _vm.entityMetadata.metadataType == _vm.metadataType.String
        ? _c(
            "div",
            { staticClass: "entity-metadata-string-value" },
            [
              _c("v-text-field", {
                attrs: {
                  clearable: "",
                  dense: "",
                  "hide-details": "",
                  label: "valore",
                },
                model: {
                  value: _vm.entityMetadata.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.entityMetadata, "value", $$v)
                  },
                  expression: "entityMetadata.value",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }